<template>
  <hm-content title="">
    <div class="">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item label="每日总提现总额限制:" prop="dayTotalAmountLimit">
          <div>
            系统每日总提现达到
            <el-input
              clearable
              size="small"
              v-model="ruleForm.dayTotalAmountLimit"
              @input="filterGt0OrFixed2('dayTotalAmountLimit')"
              @mousewheel.prevent.native
              maxlength="50"
            ></el-input>
            元后，提现申请将进入人工审核。
          </div>
        </el-form-item>
        <el-form-item label="会员单日提现限制:" prop="customerDayAmountLimit">
          <div>
            每日提现超过
            <el-input
              clearable
              size="small"
              v-model="ruleForm.customerDayAmountLimit"
              type="number"
              onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"
              @input="filterGt0OrFixed0('customerDayAmountLimit')"
              @mousewheel.prevent.native
              maxlength="50"
            ></el-input>
            元后，提现申请将进入人工审核。
          </div>
        </el-form-item>
        <el-form-item label="单笔提现限制: " prop="amountLimit">
          <div>
            单笔提现最低
            <el-input
              clearable
              size="small"
              v-model="ruleForm.minAmountLimit"
              @input="filterGt0OrFixed2('minAmountLimit')"
              @mousewheel.prevent.native
              maxlength="50"
            ></el-input>
            元，最高
            <el-input
              clearable
              size="small"
              v-model="ruleForm.maxAmountLimit"
              @input="filterGt0OrFixed2('maxAmountLimit')"
              @mousewheel.prevent.native
              maxlength="50"
            ></el-input
            >元。
          </div>
        </el-form-item>
        <el-form-item label="支付宝提现:" prop="alipayGetcashStatus">
          <div>
            <el-switch
              v-model="ruleForm.alipayGetcashStatus"
              active-text="开启"
              inactive-text="关闭"
              active-value="yes"
              inactive-value="no"
              active-color="#2d8"
              inactive-color="#ff4949"
            >
            </el-switch>
            <!-- <el-radio-group v-model="ruleForm.alipayGetcashStatus">
              <el-radio label="yes">
                开启
              </el-radio>
              <el-radio label="no">
                关闭
              </el-radio>
            </el-radio-group> -->
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="btn-wrapper flex flex-center">
      <el-button @click="submitRuleForm('ruleForm')" size="small" type="primary"
        >保存</el-button
      >
      <el-button @click="$router.back(-1)" size="small">返回</el-button>
    </div>
  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    const patternamountLimit = function(rule, val, callback) {
      if (
        this.ruleForm.maxAmountLimit === "" ||
        this.ruleForm.minAmountLimit === ""
      ) {
        return callback(new Error("请填写单笔提现限制"));
      } else {
        if (this.ruleForm.maxAmountLimit < this.ruleForm.minAmountLimit) {
          return callback(new Error("最低值不能大于最高值"));
        }
      }

      callback();
    }.bind(this);
    return {
      ruleForm: {
        dayTotalAmountLimit: "",
        customerDayAmountLimit: "",
        amountLimit: "",
        maxAmountLimit: "",
        minAmountLimit: "",
        alipayGetcashStatus: "",
        id: ""
      },
      rules: {
        dayTotalAmountLimit: [
          {
            required: true,
            message: "请输入每日总提现总额限制",
            trigger: "blur"
          }
        ],
        customerDayAmountLimit: {
          required: true,
          message: "请输入会员单日提现限制",
          trigger: "blur"
        },
        amountLimit: {
          required: true,
          validator: patternamountLimit,
          trigger: "blur"
        },
        alipayGetcashStatus: {
          required: true,
          trriger: "blur",
          message: "是否开启支付宝提现"
        }
      }
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryDetails();
  },
  methods: {
    async queryDetails() {
      const { result } = await this.$store.dispatch("detailswithdrawalRules");
      if (result) {
        for (let key in this.ruleForm) {
          this.ruleForm[key] = result[key];
        }
      }
    },
    async submitRuleForm(formName) {
      const valid = await this.$refs[formName].validate();
      if (valid) {
        let params = this.ruleForm;
        const { code } = await this.$store.dispatch(
          "editWithdrawalRules",
          params
        );
        if (code === "0") {
          this.$message({
            message: " 操作成功",
            type: "success"
          });

          this.queryDetails();
        }
      }
    },
    filterGt0OrFixed0(prop) {
      this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)|[^\d]+/g, "");
      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, ""); //两个连续的"."仅保留第一个"."
    },
    filterGt0OrFixed2(prop) {
      // this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm[prop] = this.ruleForm[prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (this.ruleForm[prop].indexOf(".") < 0 && this.ruleForm[prop] != "") {
        //首位是0的话去掉
        this.ruleForm[prop] = parseFloat(this.ruleForm[prop]);
      }
    }
  }
};
</script>
<style lang="scss" scoped></style>
